module.exports = "h5 {\r\n    line-height: 1.5;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/delete-modal/delete-modal.component.css
// module id = ./src/app/shared/components/delete-modal/delete-modal.component.css
// module chunks = main